// namespace
window.Components = window.Components || {};

(function($) {

  'use strict';

  function Item() {

    var self = this,
      $el = null,
      $itemBlock1 = null,
      $itemBlock2 = null,
      $itemBlock3 = null,
      $itemBlock4 = null,

      options = {
        example: null,
      };



    /**
     * Generic resize
     */
    function onResize() {
      // Example
      if (window.bp.getLastValue() !== window.bp.getValue()) {
        if (window.bp.getValue() !== 'xs') {
          // Items Equal Height
          Utils.setEqualHeight($itemBlock1);
          Utils.setEqualHeight($itemBlock2);
          Utils.setEqualHeight($itemBlock3);
          Utils.setEqualHeight($itemBlock4);

        } else {
          Utils.removeEqualHeight($itemBlock1);
          Utils.removeEqualHeight($itemBlock2);
          Utils.removeEqualHeight($itemBlock3);
          Utils.removeEqualHeight($itemBlock4);
        }
      }
    }


    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(opts) {
      // extends options
      for (var i in opts) { options[i] = opts[i]; }


      // Caching
      $el = options.$el;
      $itemBlock1 = $('.js-item-block1');
      $itemBlock2 = $('.js-item-block2');
      $itemBlock3 = $('.js-item-block3');
      $itemBlock4 = $('.js-item-block4');


      // *************
      window.cache.$window.on('resize', Utils.debounce(onResize, 3000));
      // Initial call on load
      onResize();
    };

    self.initialize.apply(self, arguments);
    return self;
  }

  /* Namespace declaration */
  window.Components.Item = Item;

}(jQuery));
